export default __webpack_public_path__ + "static/media/story-telling-game.1e9a22cc.png";